import { View, Text } from 'react-native'

// styles
import { globalStyles } from '../../static/styles/global'

// components
import Card from '../shared/card/Card'

type ScreenStatusProps = {
  message: string
  noGap?: boolean
  noHGap?: boolean
  noVGap?: boolean
}

const ScreenStatus = ({
  message,
  noGap = false,
  noHGap = false,
  noVGap = false
}: ScreenStatusProps): JSX.Element => {
  return (
    <>
      <View
        style={[
          globalStyles.primaryBgColor,
          globalStyles.containerBand,
          globalStyles.containerBandMenu
        ]}
      ></View>
      <View
        style={[
          globalStyles.containerOverlap,
          noGap && globalStyles.containerOverlapNoGap,
          noHGap && globalStyles.containerOverlapNoHGap,
          noVGap && globalStyles.containerOverlapNoVGap,
          globalStyles.mb4
        ]}
      >
        <Card>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.hCenterItems,
              globalStyles.pt5,
              globalStyles.pb5
            ]}
          >
            <Text style={[globalStyles.text]}>{message}</Text>
          </View>
        </Card>
      </View>
    </>
  )
}

export default ScreenStatus
